module.exports = __webpack_public_path__ + "img/y-1.66de4af2.jpg";